import React from 'react';
import { Link } from 'react-router-dom';

import { ChevronRightIcon } from '@/components/Icon';
import { colors } from '@/const/colors';

const GuideSection = ({}) => {
  return (
    <div>
      <div className="px-4">
        <p className="pt-1 pb-4 font-semibold text-gray-8">중고 화물차 똑똑하게 사고 파는 법</p>
      </div>
      <div className="px-4 flex flex-col gap-3">
        <Link to={'/guide/sale'}>
          <div className="flex flex-row items-center justify-between w-full">
            <div className="flex items-center gap-3">
              <div className="bg-[#F1F5FF] rounded-lg flex justify-center items-center w-[70px] h-[54px]">
                <img
                  src={`https://zigtruck-service-public-image.s3.ap-northeast-2.amazonaws.com/purchase_guide.png`}
                  alt="중고 화물차 판매 가이드"
                  width={44}
                  height={44}
                ></img>
              </div>
              <div>
                <p className="text-gray-6 font-semibold text-[12px] leading-[15px] mb-[4px]">판매 가이드 보러가기</p>
                <div className="font-semibold text-gray-8 text-[16px] leading-[24px]">중고 화물차 판매 가이드</div>
              </div>
            </div>
            <ChevronRightIcon color={colors.gray[5]} width={24} height={24}></ChevronRightIcon>
          </div>
        </Link>
        <Link to={'/guide/perchase'}>
          <div className="flex flex-row items-center justify-between w-full">
            <div className="flex items-center gap-3">
              <div className="bg-[#F1F5FF] rounded-lg flex justify-center items-center w-[70px] h-[54px]">
                <img
                  src={`https://zigtruck-service-public-image.s3.ap-northeast-2.amazonaws.com/sale_guide.png`}
                  alt="중고 화물차 구매 가이드"
                  width={44}
                  height={44}
                ></img>
              </div>
              <div>
                <p className="text-gray-6 font-semibold text-[12px] leading-[15px] mb-[4px]">구매 가이드 보러가기</p>
                <div className="font-semibold text-gray-8 text-[16px] leading-[24px]">중고 화물차 구매 가이드</div>
              </div>
            </div>
            <ChevronRightIcon color={colors.gray[5]} width={24} height={24}></ChevronRightIcon>
          </div>
        </Link>
      </div>

      {/* <div className="flex mx-4 gap-3 grid grid-cols-2">
        <Link to={'/guide/sale'}>
          <div className="w-full bg-[#00ACFD] rounded-lg flex justify-center mr-1 pl-3 min-w-[120px]">
            <p className="font-bold text-sm text-white min-w-[70px] mt-3 break-keep">
              중고 화물차
              <br />
              판매 가이드
            </p>
            <div className="pb-2 h-[100px] overflow-hidden rounded-lg">
              <div className="w-[163px] overflow-hidden">
                <img
                  src="https://zigtruck-service-public-image.s3.ap-northeast-2.amazonaws.com/thumbnail_purchase_guide.png"
                  alt="thumbnail_purchase_guide"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
          <p className="pt-2 font-semibold text-gray-8">판매 가이드 보러가기</p>
        </Link>
        <Link to={'/guide/perchase'}>
          <div className="w-full bg-[#1A72F5] rounded-lg flex justify-center mr-1 pl-3 min-w-[120px]">
            <p className="font-bold text-sm text-white min-w-[70px] mt-3 break-keep">
              중고 화물차
              <br />
              구매 가이드
            </p>
            <div className="pb-2 h-[100px] overflow-hidden rounded-lg">
              <div className="w-[163px] overflow-hidden">
                <img
                  src="https://zigtruck-service-public-image.s3.ap-northeast-2.amazonaws.com/thumbnail_sale_guide.png"
                  alt="thumbnail_sale_guide"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
          <p className="pt-2 font-semibold text-gray-8">구매 가이드 보러가기</p>
        </Link>
      </div> */}
    </div>
  );
};

export default GuideSection;
